import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/banner/oneday_240225oneday/sp.png'
import _imports_1 from '@/assets/images/banner/mentalnc/sp.jpg'
import _imports_2 from '@/assets/images/banner/wellfuture/sp.png'
import _imports_3 from '@/assets/images/banner/oneday_240225oneday/pc.png'
import _imports_4 from '@/assets/images/banner/mentalnc/pc.jpg'
import _imports_5 from '@/assets/images/banner/wellfuture/pc.png'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  href: "https://saipon.jp/h/xme885",
  target: "_blank"
}
const _hoisted_3 = {
  key: 1,
  href: "https://mentalnc.com/noisecanceling/sl/SN2g",
  target: "_blank"
}
const _hoisted_4 = { class: "message text-xl" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  href: "https://saipon.jp/h/xme885",
  target: "_blank"
}
const _hoisted_7 = {
  key: 1,
  href: "https://mentalnc.com/noisecanceling/sl/SN2g",
  target: "_blank"
}
const _hoisted_8 = { class: "message text-3xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.store.state.base.responsive.isMD)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.show_oneday_240225oneday)
          ? (_openBlock(), _createElementBlock("a", _hoisted_2, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("img", {
                loading: "lazy",
                src: _imports_0,
                alt: "thumbnail",
                class: "w-full hover:opacity-75 cursor-pointer my-2"
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.is_mentalnc_main && !_ctx.is_mentalnc_main_new)
          ? (_openBlock(), _createElementBlock("a", _hoisted_3, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("img", {
                loading: "lazy",
                src: _imports_1,
                alt: "thumbnail",
                class: "w-full hover:opacity-75 cursor-pointer my-1"
              }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_ctx.is_wellfuture && _ctx.left_days > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_4, "募集締め切りまで、あと" + _toDisplayString(_ctx.left_days) + "日", 1),
                    _cache[2] || (_cache[2] = _createElementVNode("a", {
                      href: "https://mentalnc.com/wellfuture/4lqDh7",
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        loading: "lazy",
                        src: _imports_2,
                        alt: "thumbnail",
                        class: "w-full hover:opacity-75 cursor-pointer my-1"
                      })
                    ], -1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
            ], 64))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (_ctx.show_oneday_240225oneday)
          ? (_openBlock(), _createElementBlock("a", _hoisted_6, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("img", {
                loading: "lazy",
                src: _imports_3,
                alt: "thumbnail",
                class: "w-full hover:opacity-75 cursor-pointer my-2"
              }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        (!_ctx.is_mentalnc_main && !_ctx.is_mentalnc_main_new)
          ? (_openBlock(), _createElementBlock("a", _hoisted_7, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("img", {
                loading: "lazy",
                src: _imports_4,
                alt: "thumbnail",
                class: "w-full hover:opacity-75 cursor-pointer my-1"
              }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
              (!_ctx.is_wellfuture && _ctx.left_days > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_8, "募集締め切りまで、あと" + _toDisplayString(_ctx.left_days) + "日", 1),
                    _cache[5] || (_cache[5] = _createElementVNode("a", {
                      href: "https://mentalnc.com/wellfuture/4lqDh7",
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        loading: "lazy",
                        src: _imports_5,
                        alt: "thumbnail",
                        class: "w-full hover:opacity-75 cursor-pointer my-1"
                      })
                    ], -1))
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
            ], 64))
      ]))
}